/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { DistillationColumn2 } from "./modelDistillationColumn2";

class ControllerDistillationColumn2 extends ControllerModel {
  constructor() {
    super("ControllerDistillationColumn2");

    this.setNewNode = (callback) => {
      let distillationColumn2 = new DistillationColumn2();
      distillationColumn2.decorate(callback);

      this.addNode(distillationColumn2);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let distillationColumn2 = new DistillationColumn2();
      distillationColumn2.copyFrom(node);
      distillationColumn2.decorate(callback);
      this.addNode(distillationColumn2);
    };

    this.getProperties = async (node) => {
      let n = new DistillationColumn2();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new DistillationColumn2();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerDistillationColumn2 };
